export default class LogoVersion {
	/** @type {string} */
	id;
	/** @type {string} */
	thumbUrl;
	/**
	 * 
	 * @param {Partial<LogoVersion>=} initialState 
	 */
	constructor(initialState) {
		Object.assign(this, initialState);
	}
}


// WEBPACK FOOTER //
// ./src/models/LogoVersion.js